import {
  AddPage,
  EditPage,
  TablePage,
  ViewPage,
} from 'src/views/logisticsadmin/containertype'

import pathMap from 'src/paths/PathMap_LogisticsAdmin'

class ContainerTypeRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.CONTAINER_TYPE_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.CONTAINER_TYPE_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.CONTAINER_TYPE_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.CONTAINER_TYPE_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default ContainerTypeRoute
